
// const api = process.env.NODE_ENV === "production" 
// ? "https://api.hureacts.com/V2/controller" 
// : "http://localhost:7730/controller";
const api = "https://api.hureacts.com/V2/controller";
const uploadUrl = "https://react.hu-st.com/upload.php";
const fileUrl = "https://react.hu-st.com/";
const nophoto = "https://react.hu-st.com/noimage.png";
const askdetempty = "0000000000";

const AZ_Flag = "https://react.hu-st.com/AZ.png";
const EN_Flag = "https://react.hu-st.com/EN.png";

function ShowLink(value) {
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
  return value;
}

function Round2(num) {
  return Math.round(num * 100) / 100;
}

function LangText(text, lng) {
  if (!text) return;
  var arr = text.split("//");
  var res;
  if (arr.length === 1) res = text;
  else res = arr[lng];

  return res;
}

export { ShowLink, HtmlNewLine, uploadUrl, fileUrl, nophoto, api, Round2, askdetempty, LangText, AZ_Flag, EN_Flag };
